export { RENDERER_TYPE, htmlRenderer } from "./htmlRenderer.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/renderers/htmlRenderer/index.mjs
// module id = 572
// module chunks = 1